import { FormTypes } from '../../../../components/FormGenerator';
import VenueRegistrationFormModal from '../../shared/VenueRegistrationFormModal';

class BasicInformationAddressDetails extends VenueRegistrationFormModal {
	constructor() {
		super({
			modalSelector: '#address-details-form-modal',
			triggerSelectors: ['.js-basic-info-add-address-details', '.js-basic-info-edit-address-details'],
			stepsEndpointAttr: 'address-details-steps-endpoint',
			submitEndpointAttr: 'address-details-submit-endpoint',
			wrapperSelector: '.p-venue-registration-basic-info',
			sectionWrapperSelector: '.p-venue-registration-basic-info-wrapper',
			logPrefix: 'BasicInformationAddressDetails'
		});
	}

	getFormGeneratorOptions() {
		return {
			totalSteps: 1,
			formType: FormTypes.SectionForm,
			exitButtonLabel: 'Save and Exit',
			showExitWithoutSavingButton: true,
			exitWithoutSavingButtonLabel: 'Exit without saving',
			exitWithoutSavingButtonHandler: () => this.closeFormModal(),
			submitButton: {
				title: 'Save and continue',
				alwaysVisible: true
			}
		};
	}

	afterFormGeneratorInit() {
		const deliveryAddressQuestionId = 3;
		const checkboxQuestion = this.formGenerator?.questions?.find(
			(question) => question.fieldName === 'deliveryAddressSameAsOrganisation'
		);

		if (!checkboxQuestion?.ref) {
			return;
		}

		checkboxQuestion.ref.onChange((answer) => {
			const isSameAsOrganisation = (answer?.value || []).some((option) => option?.id === 'same');

			// Invert default dependent behaviour: show delivery address only when unchecked
			if (isSameAsOrganisation) {
				this.formGenerator.beforeDepChangeHandler([], [deliveryAddressQuestionId]);
			} else {
				this.formGenerator.beforeDepChangeHandler([deliveryAddressQuestionId], []);
			}
		});
	}
}

VenueRegistrationFormModal.boot(BasicInformationAddressDetails);
export default BasicInformationAddressDetails;
